<template lang="pug">
  #organization
    BLoading(
      v-if="!pageReady"
      :active="!pageReady"
    )
    WtTile(v-else vertical)
      MobilePreventativeChallenge

</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import { mapActions, mapGetters } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import MobilePreventativeChallenge from "@@/PreventativeChallengeMobile/MobilePreventativeChallenge";
export default {
  name: "PreventativeChallengeMobile",
  components: {
    WtTitle,
    WtTile,
    MobilePreventativeChallenge
  },
  props: {},
  computed: {
    ...mapGetters("challenges", ["mobileChallenge", "mobileChallengeLoaded"]),
    pageReady() {
      return this.mobileChallengeLoaded;
    }
  },
  watch: {},
  async mounted() {
    await this.mobileFetchMemberData(this.$route.params.mobileToken);
    await this.mobileFetchChallenges(this.$route.params.mobileToken);
    await this.fetchMobileChallenge({
      mobileToken: this.$route.params.mobileToken,
      challengeId: this.$route.params.challengeId
    });
  },
  methods: {
    ...mapActions("organizations", ["fetchMobileMember"]),
    ...mapActions("challenges", ["fetchMobileChallenge"]),
    ...mapActions("members", ["mobileFetchChallenges", "mobileFetchMemberData"])
  }
};
</script>

<style lang="sass" scoped></style>
